
export class ControlResizerOptions {

  screenHeight: number;
  headerHeight: number;
  subMenuHeight: number;
  elemTop?: number | null = null;
  offsetTopHeight: number;
  offsetBottomHeight: number;
  footerHeight: number ;
  
  constructor(options?: Partial<ControlResizerOptions>) {
    this.screenHeight = options?.screenHeight ?? window.innerHeight;
    this.headerHeight = options?.headerHeight ?? 50; // Default header height is 50 if not provided
    this.subMenuHeight = options?.subMenuHeight ?? 0; // Default submenu height is 0 if not provided
    this.elemTop = options?.elemTop ?? null;
    this.offsetTopHeight = options?.offsetTopHeight ?? 0;
    this.offsetBottomHeight = options?.offsetBottomHeight ?? 0;              // Default offset from top of page is 0 if not provided
    this.footerHeight = options?.footerHeight ?? 30; // Default footer height is 50 if not provided    
  }
}
